// Krok ruchu z kolizjami – IDENTYCZNY z simulation/sim/physics.py. Dzięki temu predykcja klienta
// zgadza się z serwerem co do bitu (te same operacje na liczbach double).
import { PLAYER_RADIUS_M, PLAYER_SPEED_MPS, STEP_S } from '../net/protocol.js';

export type BlockedFn = (tx: number, ty: number) => boolean;

function blockedAt(x: number, y: number, tile: number, blocked: BlockedFn, r = PLAYER_RADIUS_M): boolean {
  const pts: [number, number][] = [[x - r, y - r], [x + r, y - r], [x - r, y + r], [x + r, y + r]];
  for (const [cx, cy] of pts) {
    if (blocked(Math.floor(cx / tile), Math.floor(cy / tile))) return true;
  }
  return false;
}

export function step(x: number, y: number, dx: number, dy: number, tile: number, blocked: BlockedFn,
                     speed = PLAYER_SPEED_MPS, dt = STEP_S): [number, number] {
  const len = Math.hypot(dx, dy);
  if (len < 1e-9) return [x, y];
  dx /= len; dy /= len;
  const nx = x + dx * speed * dt;
  if (!blockedAt(nx, y, tile, blocked)) x = nx;
  const ny = y + dy * speed * dt;
  if (!blockedAt(x, ny, tile, blocked)) y = ny;
  return [x, y];
}

/** Kierunek z joysticka/klawiatury → wektor jednostkowy w układzie świata.
 *  Ekran izometryczny: "w górę" na ekranie = na północny zachód świata (−x, −y). */
export function screenDirToWorld(sx: number, sy: number): [number, number] {
  const wx = sx + sy, wy = sy - sx;
  const len = Math.hypot(wx, wy);
  return len < 1e-6 ? [0, 0] : [wx / len, wy / len];
}
